module.exports = require("ember-gesture-modifiers/modifiers/did-pan");